import { supabase } from '../../../../services/supabase';

export interface User {
  id: string;
  first_name: string;
  last_name: string;
  email: string;
  type: string;
  avatar_url: string | null;
}

export async function fetchAllUsers(): Promise<User[]> {
  const { data, error } = await supabase
    .from('users')
    .select('id, first_name, last_name, email, type, avatar_url')
    .order('first_name');

  if (error) {
    throw new Error(`Failed to fetch users: ${error.message}`);
  }

  return data || [];
}
